// Schalter pricing_enforcement aus dem FEATURE_FLAGS-System. Konfiguration,
// Overrides pro Testkunde und Notaus stehen in
// src/features/experiments/README.md im Abschnitt „Rollout pricing_enforcement".
//
// Jest-Tests, die diese Datei laden, mocken ../experiments/track-exposure und
// ../experiments/use-feature-flags-query, beide ziehen aws-amplify. Dazu
// ../../helpers wegen hasConsentFor in visitor-id.js.
import { useMemo } from 'react'

import { useFlag, useFlagsLoaded } from '../experiments'

export const PRICING_ENFORCEMENT_FLAG = 'pricing_enforcement'

/**
 * Ob der Schalter für diesen Partner an ist. Solange die Flags nicht geladen
 * sind, ist er aus. Fehlt das Flag oder schlägt das erste Laden fehl, ebenso.
 * Ein fehlgeschlagenes Neuladen behält den letzten Stand
 * (use-feature-flags-query.js).
 *
 * partnerId geht explizit in den Kontext, weil der StartupHandler das
 * Partner-Singleton erst in einem Effect setzt. Ohne partnerId ist der
 * Schalter aus, auch wenn das Flag einen Override hat. track false, ein
 * Rollout schreibt keine Exposures.
 *
 * @param {string|null|undefined} partnerId
 * @returns {{ on: boolean, loaded: boolean }}
 */
export const usePricingEnforcementFlag = (partnerId) => {
  const loaded = useFlagsLoaded()
  const flag = useFlag(PRICING_ENFORCEMENT_FLAG, {
    ctx: { partnerId: partnerId || null },
    track: false
  })
  const on = loaded && flag

  return useMemo(() => ({ on, loaded }), [on, loaded])
}
